

class BaseViewController {

    constructor($scope, $state,  LoadedModel) {
        this._$scope = $scope;
        this._$state = $state;

        this.model = LoadedModel;

        this.updateEvent = 'updateView';

        this.meshViewKey = 'mesh';
        this.feasibilityViewKey = 'feasibility';
        this.thinningViewKey = 'thinning';
        this.blankViewKey = 'blank';
        this.nestViewKey = 'nest';
    }

    getCurrentView() {
        return this.model.getView(this.viewKey);
    }

    loadView(view, key) {
        let self = this;
        setTimeout(() => {
            self._$scope.$broadcast(self.updateEvent, [undefined, view, key])
        });
    }

    updateView(key) {
        this.loadViewByData(this.model.getViewData(key), key);
    }

    loadViewByData(data, key) {
        let self = this;
        setTimeout(() => {
            self._$scope.$broadcast(self.updateEvent, [data, undefined, key]);
        }, 0);
    }

    loadViewOrUpdate(key) {
        let view = this.model.getView(key);
        if(view) {
            this.loadView(view, key);
        } else {
            this.updateView(key);
        }
    }

    loadCurrentView() {
        this.loadView(this.getCurrentView(), this.viewKey);
    }

    updateCurrentView(data, key = this.viewKey) {
        this.loadViewByData(data, key);
    }

}

export default BaseViewController;



// WEBPACK FOOTER //
// ./client/app/common/services/base-view-controller.js